import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=dd61d7e6&"
import script from "../../services/admin/admin-index.js?vue&type=script&lang=js&"
export * from "../../services/admin/admin-index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports